import { add } from "date-fns";
import { datatype, lorem, random } from "faker/locale/en_US";

import { STALE_DEAL_DAYS } from "../../../dashboard/staleDeals";
import {
  defaultDealCategories,
  defaultDealStages,
} from "../../../root/defaultConfiguration";
import type { Deal } from "../../../types";
import type { Db } from "./types";
import { randomDate } from "./utils";

export const generateDeals = (db: Db): Deal[] => {
  const deals = Array.from(Array(50).keys()).map((id) => {
    const company = random.arrayElement(db.companies);
    company.nb_deals = (company.nb_deals ?? 0) + 1;
    const contacts = random.arrayElements(
      db.contacts.filter((contact) => contact.company_id === company.id),
      datatype.number({ min: 1, max: 3 }),
    );
    const lowercaseName = lorem.words();
    const created_at = randomDate(new Date(company.created_at)).toISOString();

    const expected_closing_date = randomDate(
      new Date(created_at),
      add(new Date(created_at), { months: 6 }),
    )
      .toISOString()
      .split("T")[0];

    const updated_at = randomDate(new Date(created_at)).toISOString();
    const amount = datatype.number(1000) * 100;

    return {
      id,
      name: lowercaseName[0].toUpperCase() + lowercaseName.slice(1),
      company_id: company.id,
      contact_ids: contacts.map((contact) => contact.id),
      category: random.arrayElement(defaultDealCategories).value,
      stage: random.arrayElement(defaultDealStages).value,
      description: lorem.paragraphs(datatype.number({ min: 1, max: 4 })),
      amount,
      valor_negociado:
        datatype.number(1) === 0 ? Math.round(amount * 0.9) : null,
      created_at,
      updated_at,
      last_activity_at: updated_at,
      archived_at: null,
      expected_closing_date,
      sales_id: company.sales_id!,
      index: 0,
    };
  });
  // Guarantee a few open deals are old enough for the manager stale-deals block.
  const day = 24 * 60 * 60 * 1000;
  const staleSamples = [
    { daysAgo: STALE_DEAL_DAYS, stage: "planejada" },
    { daysAgo: STALE_DEAL_DAYS + 10, stage: "primeiro-contato" },
    { daysAgo: STALE_DEAL_DAYS + 21, stage: "proposta-enviada" },
    { daysAgo: STALE_DEAL_DAYS + 35, stage: "em-negociacao" },
  ];
  staleSamples.forEach((sample, index) => {
    const deal = deals[index];
    if (!deal) return;
    const lastActivityAt = new Date(
      Date.now() - sample.daysAgo * day,
    ).toISOString();
    deal.stage = sample.stage;
    deal.archived_at = null;
    deal.last_activity_at = lastActivityAt;
    deal.updated_at = lastActivityAt;
  });
  // compute index based on stage
  defaultDealStages.forEach((stage) => {
    deals
      .filter((deal) => deal.stage === stage.value)
      .forEach((deal, index) => {
        deals[deal.id].index = index;
      });
  });
  return deals;
};
